'use client'

import { motion } from 'framer-motion'

export default function HeroSection() {
    return (
        <section id='top' className='relative min-h-dvh overflow-hidden bg-dark text-on-dark'>
            <video
                className='absolute inset-0 h-full w-full object-cover'
                autoPlay
                muted
                loop
                playsInline
                preload='metadata'
                aria-hidden='true'>
                <source src='/bg.mp4' type='video/mp4' />
            </video>

            {/* More premium, less “effecty” overlay */}
            <div
                className='absolute inset-0 bg-linear-to-b from-black/80 via-black/45 to-black/85'
                aria-hidden='true'
            />
            <div
                className='absolute inset-0'
                style={{
                    background:
                        'radial-gradient(980px 520px at 18% 6%, rgba(79,140,255,0.16), transparent 60%), radial-gradient(820px 520px at 82% 0%, rgba(86,215,255,0.10), transparent 60%)'
                }}
                aria-hidden='true'
            />

            <div className='relative'>
                {/* spacing for fixed header */}
                <div className='pt-23' />

                <div className='container-x section-pad'>
                    <div className='max-w-205'>
                        {/* Label: calmer, more premium */}
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.55 }}
                            className='inline-flex items-center rounded-lg bg-white/8 px-5 py-2 shadow-sm backdrop-blur'>
                            <p className='text-[11px] font-semibold tracking-[0.34em] text-muted-on-dark'>
                                INNER LEADERSHIP COACHING
                            </p>
                        </motion.div>

                        <motion.h1
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.75, delay: 0.05 }}
                            className='mt-10 text-balance text-4xl font-semibold leading-[1.03] tracking-tight sm:text-5xl lg:text-6xl'>
                            Lead from strength,
                            <span className='block'>deliver with confidence</span>
                        </motion.h1>

                        <motion.p
                            initial={{ opacity: 0, y: 12 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.75, delay: 0.12 }}
                            className='mt-7 text-pretty text-xl leading-relaxed text-muted-on-dark sm:text-2xl'>
                            Coaching and training that turns complexity into clarity—helping leaders regulate stress,
                            align strengths, and deliver measurable outcomes.
                        </motion.p>

                        {/* Subtle scroll cue */}
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.75, delay: 0.28 }}
                            className='mt-18 flex items-center gap-3 text-[11px] font-semibold tracking-[0.28em] text-muted-on-dark'>
                            <span className='inline-flex h-9 w-6 items-start justify-center rounded-full bg-white/10 p-1 shadow-sm'>
                                <span className='mt-1.5 h-2 w-2 rounded-full bg-white/70' />
                            </span>
                            SCROLL
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    )
}
